import Vue from 'vue';


if (document.getElementById('notifications-vue')) {

    Vue.component('notifications', require('./Notifications').default);


    window.notificationsCenter = new Vue({
        name: 'Notifications',
        el: '#notifications-vue',
        methods: {
            showNotifications() {
                eventBus.$emit('showNotifications');
            },
        }
    });
}
